import { render } from "./StudentRollCallView.vue?vue&type=template&id=21331622"
import script from "./StudentRollCallView.vue?vue&type=script&lang=js"
export * from "./StudentRollCallView.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/sparta-system-front-trainer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__